import { animate, createTimeline } from 'animejs'

const spin = function (item) {
    animate(item, {
        rotate: [0, 360],
        duration: '1000',
    });
};

const spiralShink = function (item) {
    createTimeline()
    .add(item, {
        rotate: 1080,
        scale: 0.6,
        duration: '720',
    }).add(item, {
        rotate: 0,
        scale: 1,
        duration: '420',
    });
};

const coinSpin = function (item) {
    animate(item, {
        duration: '2400',
        rotateY: [0, 720],
        ease: 'outBack',
    });
};

const squatAndSquish = function (item) {
    createTimeline()
    .add(item, {
        scaleX: 0.8,
        scaleY: 0.4,
        duration: '800',
        ease: 'outQuint',
    }).add(item, {
        scaleX: 1,
        scaleY: 1,
        duration: '420',
        ease: 'outBounce',
    });
};

/* Assign random animation to all svgs */

const animationLibrary = {
    'spin': (e) => spin(e),
    'spiralShink': (e) => spiralShink(e),
    'coinSpin': (e) => coinSpin(e),
    'squatAndSquish': (e) => squatAndSquish(e),
};

const allSvgs = document.querySelectorAll('.wavy-cta');

export default () => {
    for (const element of allSvgs) {
        if (element.querySelector('.wavy-cta__graphic')) {
            let randomIndex = Math.floor(Math.random() * Object.keys(animationLibrary).length);
            let animationName = Object.keys(animationLibrary)[randomIndex];
            let graphic = element.children[1];

            element.addEventListener('mouseover', () => {
                animationLibrary[animationName](element.children[1]);
            });

            graphic.addEventListener('click', () => {
                animationLibrary[animationName](element.children[1]);
            });
        } 
    }
};
